module.exports = __webpack_public_path__ + "static/media/Tram.ee3fd5d0.png";